export default __webpack_public_path__ + "static/media/Office_2.0118c650.png";